import { useState, useEffect, memo } from "react";
import styles from "./TotalMapCount.module.css";

/**
 * @interface
 * @prop {number} total 전체 지도 수
 * @prop {string} size 컴포넌트 크기(large: 하단용 / small: 상단용)
 * @prop {boolean} isAnimated (optional) 카운팅 애니메이션 적용 여부
 */
interface TotalMapCountProps {
    total: number;
    size: string;
    isAnimated?: boolean;
}

/**
 * 전체 지도 카운트
 * @author mjkang
 * @date 2022-08-24 10:35:06
 * @param props {@link TotalMapCountProps}
 */
const TotalMapCount = (props: TotalMapCountProps) => {
    const [countNum, setCountNum] = useState(0);
    const formatter = new Intl.NumberFormat();
    const size = props.size === "large" ? styles.large : styles.small;
    const br =
        props.size === "large" ? (
            <span className={styles.inner}>
                TOTAL
                <br />
            </span>
        ) : null;

    /**
     * 전체 지도 수 카운팅 함수
     */
    useEffect(() => {
        const time = 1500;
        const cycle = 50;

        const counter = setInterval(() => {
            setCountNum((countNum) => {
                if (countNum < props.total) {
                    return countNum + Math.ceil(props.total / (time / cycle));
                } else {
                    clearInterval(counter);
                    return props.total;
                }
            });
        }, cycle);

        return () => clearInterval(counter); // cleanup
    }, [props.total]);

    return (
        <div className={styles.total}>
            <p className={[styles.title, size].join(" ")}>{br}전체지도</p>
            <p className={[styles.count, size].join(" ")}>{props.isAnimated === true ? formatter.format(countNum) : props.total}</p>
        </div>
    );
};

export default memo(TotalMapCount);
